/* Klaviyo: evento «Added Pack to Cart» para cualquier producto que se añade al carrito.
   Se engancha a las respuestas de /cart/add, así que cubre packs, muselinas, termos, regalos y cualquier producto
   nuevo sin configurar nada. Los packs de la ficha del biberón ya envían su evento completo (happymami-bundle.js,
   marca window.__hmKlaviyoPack) y aquí se saltan para no duplicarlo. */
(function () {
  if (window.__hmKlaviyoAdd || !window.fetch) return;
  window.__hmKlaviyoAdd = true;
  window.__hmKlaviyoPack = window.__hmKlaviyoPack || {};

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function lineData(item) {
    var url = item.url || '';
    return {
      ProductName: item.product_title || item.title || '',
      VariantName: item.variant_title || '',
      SKU: item.sku || '',
      ProductID: item.product_id || '',
      VariantID: item.variant_id || item.id || '',
      Quantity: item.quantity || 1,
      Price: (item.final_price != null ? item.final_price : item.price || 0) / 100,
      ImageURL: item.image || (item.featured_image && item.featured_image.url) || '',
      URL: url ? (/^https?:/.test(url) ? url : window.location.origin + url) : '',
      Type: (item.properties && item.properties._tipo) || '',
      ChoiceCode: (item.properties && item.properties._hm_choice) || '',
    };
  }

  function track(json) {
    try {
      var lines = (json && json.items) || (json && json.id ? [json] : []);
      if (!lines.length) return;
      var bundleIds = {};
      lines.forEach(function (l) {
        var b = l.properties && l.properties._bundle_id;
        if (b) bundleIds[b] = true;
      });
      // El pack de la ficha del biberón ya ha enviado su evento propio.
      if (Object.keys(bundleIds).some(function (b) { return window.__hmKlaviyoPack[b]; })) return;

      var all = lines.map(lineData);
      var main = all[0];
      var total = lines.reduce(function (sum, l) {
        return sum + (l.final_line_price != null ? l.final_line_price : (l.final_price || 0) * (l.quantity || 1));
      }, 0);
      var bundleId = Object.keys(bundleIds)[0] || '';
      var data = {
        $event_id: 'add-' + (bundleId || lines.map(function (l) { return l.key || l.id; }).join('-')) + '-' + Date.now(),
        $value: total / 100,
        BundleID: bundleId,
        PackTitle: main.ProductName,
        Currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        ItemCount: all.length,
        ItemNames: all.map(function (l) { return l.ProductName; }),
        Items: all,
        ProductName: main.ProductName,
        VariantName: main.VariantName,
        SKU: main.SKU,
        VariantID: main.VariantID,
        Quantity: main.Quantity,
        ImageURL: main.ImageURL,
        URL: main.URL,
      };
      // Código de las cuatro respuestas (P1-P4) de la tetina: solo cifras, igual en todos los idiomas.
      var coded = all.filter(function (l) { return l.ChoiceCode; })[0];
      if (coded) data['Teat Choice Code'] = coded.ChoiceCode;
      var visible = {};
      lines.forEach(function (l) {
        Object.keys(l.properties || {}).forEach(function (k) {
          if (k.charAt(0) !== '_') visible[k] = l.properties[k];
        });
      });
      if (Object.keys(visible).length) data['Cart Line Properties'] = visible;
      var permalink = lines
        .filter(function (l) { return l.variant_id || l.id; })
        .map(function (l) { return (l.variant_id || l.id) + ':' + (l.quantity || 1); })
        .join(',');
      if (permalink) data['Rebuild Cart URL'] = window.location.origin + '/cart/' + permalink;
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added Pack to Cart', data]);
    } catch (e) {}
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && ADD_RE.test(url)) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (json) {
            // Deja que el flujo de packs marque su evento antes de decidir si este sobra.
            setTimeout(function () { track(json); }, 400);
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };
})();
